import { styled } from "@mui/material/styles";

import { inkColor, panelColor } from "~/styles/redesignColors";

export const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

export const Citation = styled("p")(({ theme }) => ({
  margin: 0,
  padding: "10px 12px",
  borderRadius: 5,
  backgroundColor: panelColor(theme),
  fontSize: 13,
  lineHeight: 1.5,
  color: inkColor(theme),
  textWrap: "pretty",
}));

export const Actions = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
});
